import React, { ReactElement } from 'react';
import './pripomienkaList.scss';
import { Loader } from 'idsk-react-components';
import PripomienkaListComponent
  from './component/PripomienkaListComponent/PripomienkaListComponent';
import { ClientStatus } from '../../model/ClientStatus';
import PripomienkaListPage from '../../model/pripomienka/PripomienkaListPage';
import Uuid from '../../model/Uuid';

interface Props {
  page: PripomienkaListPage;
  status: ClientStatus;
  pageNumberFromUrl: number;
  setAssignedList?: (assignedList: Array<Uuid>) => void;
  assignedList?: Array<Uuid>;
  reloadPripomienkaListPage?(): void;
  reloadFilterData?(): void;
  isSelectedFilter?: boolean;
}

const PripomienkaList = ({
  page, status, pageNumberFromUrl,
  assignedList, setAssignedList,
  reloadPripomienkaListPage,
  reloadFilterData,
  isSelectedFilter = false,
}: Props): ReactElement => (
  <Loader loading={status.loading}>
    <>
      <PripomienkaListComponent
        pripomienkaListPage={page}
        pageNumberFromUrl={pageNumberFromUrl}
        assignedList={assignedList}
        setAssignedList={setAssignedList}
        reloadPripomienkaListPage={reloadPripomienkaListPage}
        reloadFilterData={reloadFilterData}
        isSelectedFilter={isSelectedFilter}
      />
    </>
  </Loader>
);

export default PripomienkaList;
